import React, { useContext, useState, useEffect, memo } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Icon,
  Card,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import {
  HeaderModal,
  ModalCancelamento,
  FontButton,
} from "../styles/GerenciamentoContrato";
import TextField from "../../../../components/basics/TextFieldErp";
import GerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { findCliente } from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const ModalEmailContact = ({
  modalOpen,
  setModalOpen,
  modelo,
  setMainLoading,
}) => {
  const { queryParams } = useContext(QueryParamsContext);

  const { sendEmailPdf } = GerenciamentoContratoController();

  useEffect(() => {
    (async () => {
      setMainLoading(true);

      try {
        const groupMails = [];

        const client = await findCliente({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: modelo.idcliente,
          include: "clientescontatos",
        });

        if (!client.success) return;

        if (client.data.email && client.data.email_utilizarfinanceiro === "S") {
          const strMail = client.data.email.replace(/\s/g, "");
          const arrMails = strMail.split(";");
          arrMails.forEach((element) => {
            if (element) {
              groupMails.push(element.toLowerCase());
            }
          });
        }

        if (client.data.clientescontatos.length) {
          // eslint-disable-next-line array-callback-return
          client.data.clientescontatos.map((row, key) => {
            if (row.email && row.email_utilizarfinanceiro === "S") {
              groupMails.push(row.email.toLowerCase());
            }
          });
        }
        setEmails(groupMails);
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
  }, [queryParams.empresa_cnpj, modelo.idcliente, setMainLoading]);

  const handleClose = () => {
    setModalOpen(false);
  };

  const addListEmail = () => {
    if (email && email.trim()) {
      const groupMails = [...emails];
      groupMails.push(email.toLowerCase());

      setEmail("");
      setEmails(groupMails);
    }
  };

  const removeListEmail = (index) => {
    let groupMails = [...emails];
    groupMails.splice(index, 1);

    setEmails(groupMails);
  };

  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState("");

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="dialog-email-modelo"
    >
      <ModalCancelamento>
        <HeaderModal>
          <DialogTitle id="dialog-email-modelo">
            <Chip
              label="Envio de Email do Contrato"
              bgcolor="primary"
              textcolor="white"
            />
          </DialogTitle>
        </HeaderModal>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <Typography variant="subtitle2" gutterBottom>
                Deseja adicionar mais emails?
              </Typography>
            </Grid>
            <Grid item sm>
              <TextField
                label="Email"
                size="small"
                variant="filled"
                value={email}
                setValue={setEmail}
              />
            </Grid>
            <Grid item>
              <Btn
                full="true"
                bgcolor="lightgreen"
                textcolor="white"
                hovercolor="blue"
                onClick={addListEmail}
                label={<Icon>add</Icon>}
              />
            </Grid>
            <Grid item sm={12}>
              <Card fullWidth>
                {emails.map((value, index) => (
                  <Chip
                    onDelete={() => {
                      removeListEmail(index);
                    }}
                    key={index}
                    label={value}
                    bgcolor="secondary"
                    textcolor="black"
                  />
                ))}
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <FontButton>
            <Grid container spacing={2}>
              <Grid item sm />
              <Grid item sm>
                <Btn
                  bgcolor="tertiary"
                  hovercolor="blue"
                  onClick={handleClose}
                  label="Cancelar"
                  full="true"
                />
              </Grid>
              <Grid item sm>
                <Btn
                  label="Enviar Email"
                  full="true"
                  onClick={() => {
                    sendEmailPdf(modelo.id, emails, setModalOpen);
                  }}
                />
              </Grid>
            </Grid>
          </FontButton>
        </DialogActions>
      </ModalCancelamento>
    </Dialog>
  );
};

export default memo(ModalEmailContact);
